export const NO_SUB_CATEGORIES_HELPER_TEXT = 'No sub-categories configured for this category';
